var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.isTypeLabel ? 'cursor-pointer flex gap-2 items-center' : '', _vm.isTypeLabel ? _vm.classIconLabel : _vm.classIcon]},[_c('Icon',{attrs:{"icon":_vm.icon,"size":_vm.sizeIcon}}),(_vm.isTypeLabel)?_c('p',{class:_vm.classLabel},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }